import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { withStyles } from "@material-ui/core/styles";
import { isString, isEmpty } from "lodash";
import { Row, Col, Container } from "deltoid/core/Blocks/BootstrapContainers";

import styles from "./multipleUploaderStyles";
import { SpinLoader } from "deltoid/core/Loaders";

const MultipleFileUploader = ({
  classes,
  onFileDropAccepted,
  onFileDropRejected,
  uploadedDocument,
  allowedFileExtensions,
  maxFileSizeInMB,
  onRemove,
  disabled,
  multiple,
  onUploadIconClick,
}) => {
  const onDropAccepted = (acceptedFiles) => {
    onFileDropAccepted(acceptedFiles);
  };
  const onDropRejected = (rejectedFiles) => {
    onFileDropRejected(rejectedFiles);
  };

  const { getRootProps, open, getInputProps } = useDropzone({
    onDropAccepted,
    onDropRejected,
    disabled,
    accept: allowedFileExtensions,
    maxSize: maxFileSizeInMB * 1024 * 1024,
    multiple: true,
  });

  const handleRemoveFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onRemove();
  };

  const handleUploadIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onUploadIconClick(e);
  };

  return (
    <div
      {...getRootProps({ className: `${classes.dropUploader}` })}
      onClick={onUploadIconClick ? handleUploadIconClick : open}
    >
      <input {...getInputProps()} />
      <div
        className={classes.uploadIcon}
      >
        <UploadIcon width="16" height="16" />
      </div>
      <div className={`${classes.contentText}`}>
        <span className={classes.uploaderText}>Choose file</span> or drag files here
      </div>
    </div>
  );
};

export default withStyles(styles)(MultipleFileUploader);
const UploadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" transform="translate(-6 -6)" />
        <g fill="#808080" fillRule="nonzero">
          <path
            d="M8.907 3.128l-2.625-3C6.211.048 6.108 0 6 0c-.108 0-.21.047-.282.128l-2.625 3c-.097.111-.12.268-.06.402.062.134.195.22.342.22h1.5v4.875c0 .207.168.375.375.375h1.5c.207 0 .375-.168.375-.375V3.75h1.5c.147 0 .28-.086.341-.22s.039-.291-.059-.402z"
            transform="translate(-6 -6) translate(6 6)"
          />
          <path
            d="M10.4 8v2.4H1.6V8H0v3.2c0 .442.358.8.8.8h10.4c.442 0 .8-.358.8-.8V8h-1.6z"
            transform="translate(-6 -6) translate(6 6)"
          />
        </g>
      </g>
    </svg>
  );
};
